import React, { FC } from 'react'
import { SponsorFragment } from 'src/graphql/generated/graphql'
import { UserCard } from '@sendoutcards/quantum-design-ui'
import { formatLocation } from 'src/helpers'
import { SelectableCard } from 'src/design_system/components/SelectableCard/SelectableCard'

type SponsorCardProps = {
  sponsor: SponsorFragment
  isActive: boolean
  onClick?: () => void
  backgroundColor?: string
}

export const SponsorCard: FC<SponsorCardProps> = ({
  sponsor,
  isActive,
  onClick,
  backgroundColor,
}) => {
  return (
    <SelectableCard
      isActive={isActive}
      onClick={onClick}
      backgroundColor={backgroundColor}
    >
      <UserCard
        profileImage={sponsor.storefront?.mugshot?.url}
        firstName={sponsor.firstName}
        lastName={sponsor.lastName}
        caption={formatLocation(
          sponsor.shippingAddress?.city,
          sponsor.shippingAddress?.state,
        )}
        size="small"
        active={isActive}
      />
    </SelectableCard>
  )
}
